import axios from "axios";
import { returnErrors } from "../store/reducers/Error";
import { returnMessages } from "../store/reducers/Message";
import { setCustomLoading } from "../store/reducers/authSlice";

export const getAddresses = async (idToken,dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get("/user/billing/address/", config);
    return response;
  } catch (error) {
    // dispatch(returnErrors("Error while Fetching address!!", error?.response?.status));
    return console.error(error.response.data); // Return specific error data from API
  }
};


export const addAddress = async (data, idToken, dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.post(
      "/user/billing/address/",
      data,
      config
    );
    dispatch(returnMessages("Address Added SuccessFully!!", 201));
    dispatch(setCustomLoading());
    return response;
  } catch (error) {
    dispatch(returnErrors("Error while Adding address!!", error?.response?.status));
    return console.error(error.response.data);
  }
};


export const editAddress = async (data, idToken, dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.patch(
      "/user/billing/address/",
      data,
      config
    );
    dispatch(returnMessages("Address Edited SuccessFully!!", 200));
    dispatch(setCustomLoading());
    return response;
  } catch (error) {
    // dispatch(returnErrors("Error while Editing address!!", error?.response?.status));
    return console.error("Error in editing", error.response.data); // Return specific error data from API
  }
};


export const deleteAddress = async (data, idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.patch(
      "/user/billing/address/",
      data,
      config
    );
    return response;
  } catch (error) {
    return console.error(error.response.data); // Return specific error data from API
  }
};
